import { getLocalizedValue } from '../constants/Languages';

const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const formatProductSaleItemLabel = (item, language) => {
  const quantity = Number(item?.quantity);
  const nameDictionary = (item?.productName && typeof item.productName === 'object')
    ? item.productName
    : (item?.name && typeof item.name === 'object' ? item.name : null);
  const name = getLocalizedValue(nameDictionary, language, undefined, '')
    || (typeof item?.productName === 'string' ? item.productName : '')
    || (typeof item?.name === 'string' ? item.name : '');
  if (!Number.isFinite(quantity) || quantity <= 0) {
    return name;
  }

  return name ? `${quantity}x ${name}` : `${quantity}x`;
};

export const formatProductLinesSummary = (products, lines, language) => (
  (lines || [])
    .map((line) => {
      const product = (products || []).find((item) => item.id === line.productId);
      return formatProductSaleItemLabel({
        quantity: line.quantity,
        productName: product?.name,
        name: product?.name,
      }, language);
    })
    .filter(Boolean)
    .join(', ')
);

export const formatProductSaleItemsSummary = (sale, language) => {
  const items = sale?.items;
  if (Array.isArray(items) && items.length > 0) {
    return items
      .map((item) => formatProductSaleItemLabel(item, language))
      .filter(Boolean)
      .join(', ');
  }

  return sale?.itemsSummary || '';
};

export const getProductSaleAmounts = (sale) => {
  const original = roundMoney(sale?.totalAmount || 0);
  const collected = roundMoney(sale?.amountReceived);
  const hasDiscount = Number.isFinite(collected) && collected < original;
  return {
    original,
    paid: hasDiscount ? collected : original,
    hasDiscount,
  };
};
